import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import React, { useState, useEffect } from "react";

import { FilterMatchMode, FilterService } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import ViewLogs from "../Modals/ViewLogs";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isAdmin } from "../Connection/Connection";

import Spinner from "react-bootstrap/Spinner";
//
const Logs = () => {
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];
  const [counter, setCounter] = useState(0);

  const history = useHistory();

  if (!isAdmin) {
    history.push("/home");
  }

  const {
    error,
    isLoading,
    data: logs,
  } = useFetch(`${main_link}logs?user_id=${user_id}`, counter);

  const [filters, setFilters] = useState({
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    ip_address: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by: { value: null, matchMode: FilterMatchMode.CONTAINS },
    action: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [show, setShow] = useState();
  const [log_id, setLog_id] = useState();

  const actionBodyTemplate = (rowData) => (
    <Button
      type="button"
      icon="nav-icon fas fa-eye"
      style={{ borderRadius: "50px" }}
      onClick={() => {
        // setLog_id(rowData.id);
        setLog_id(rowData);
        setShow(true);
      }}
    />
  );

  return (
    <>
      <ViewLogs setShow={setShow} show={show} log_id={log_id} />
      <div>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Logs Page</h1>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            {/* Default box */}
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Logs{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
              </div>
              {/* <div className="card-body "> */}
              <DataTable
                value={logs}
                sortMode="multiple"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={15}
                dataKey="id"
                filters={filters}
                filterDisplay="row"
                loading={isLoading}
                scrollable
                removableSort
                stripedRows
              >
                <Column
                  field="id"
                  header="ID"
                  sortable
                  filter
                  filterPlaceholder="Search by ID"
                ></Column>
                <Column
                  field="action"
                  header="Action"
                  sortable
                  filter
                  filterPlaceholder="Search by Action"
                ></Column>
                <Column
                  field="created_by"
                  header="Created By"
                  sortable
                  filter
                  filterPlaceholder="Search by Created By"
                ></Column>
                <Column
                  field="ip_address"
                  header="IP Address"
                  sortable
                  filter
                  filterPlaceholder="Search by Ip"
                ></Column>
                <Column
                  header="View"
                  headerStyle={{ width: "5rem", textAlign: "center" }}
                  bodyStyle={{ textAlign: "center", overflow: "visible" }}
                  body={actionBodyTemplate}
                />
              </DataTable>
              {/* </div> */}
              {/* /.card-body */}
              <div className="card-footer">Logs</div>
              {/* /.card-footer*/}
            </div>
            {/* /.card */}
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
      </div>
    </>
  );
};

export default Logs;
